const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage+1;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPageScroll);
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      colorSwatches();
    },
    complete: function() {
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl =  nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value =  nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage =  currentPage;
          scollData.querySelector('input[data-current-page]').value =  currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      } 
    }
  })
}

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
            sectionObserver.unobserve(entry.target);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMore() {  
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
// Back button support: collection pages are not kept in the browser's back/forward cache, so coming back
// reloads the page with only the first page of items. Remember how many pages were loaded and which item
// was clicked, and on "back" load those pages again and scroll to that item.
// Safari (iPhone) tries to restore the scroll position only once, early, while the page is still too short,
// and then stays at the top. So we always scroll to the clicked item ourselves, also without "Load more".
const LOAD_MORE_RESTORE_KEY = 'loadMoreRestore';

const currentListUrl = () => location.pathname + location.search;

const currentPageNumber = () => parseInt($('[data-current-page]').val()) || 1;

document.addEventListener('click', (event) => {
  // Product grid on collection pages, and product cards elsewhere (e.g. the sliders on the homepage). Outside a grid
  // there is no item to find again, so only the scroll position is restored.
  const link = event.target.closest('.load-more-grid a[href], .card-wrapper a[href*="/products/"]');
  if (!link) return;

  const item = link.closest('.load-more-grid > *');
  try {
    sessionStorage.setItem(LOAD_MORE_RESTORE_KEY, JSON.stringify({
      url: currentListUrl(),
      page: currentPageNumber(),
      index: item ? Array.prototype.indexOf.call(item.parentElement.children, item) : -1,
      offset: item ? item.getBoundingClientRect().top : 0,
      scrollY: window.scrollY
    }));
    // Mark this history entry: coming back to exactly this entry (back button) restores the position. Opening the
    // collection again through a link or menu creates a new entry without the mark and starts at the top.
    history.replaceState(Object.assign({}, history.state, { loadMoreRestore: true }), '');
  } catch (error) {}
});

const appendPage = (page) => {
  const pageUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + page);

  return $.ajax({ url: pageUrl, type: 'GET', dataType: 'html' }).then((responseHTML) => {
    $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
  });
};

// Put the clicked item back where it was on screen. Images, reviews and swatches still change the page height
// after this, so keep correcting for a few seconds, until the visitor scrolls or taps themselves.
const keepItemInPlace = (state) => {
  const place = () => {
    const grid = document.querySelector('.load-more-grid');
    const item = grid && state.index >= 0 ? grid.children[state.index] : null;
    const top = item ? item.getBoundingClientRect().top + window.scrollY - state.offset : state.scrollY;
    if (Math.abs(window.scrollY - top) > 1) window.scrollTo(0, top);
  };

  const userEvents = ['touchstart', 'wheel', 'keydown', 'mousedown'];
  const resizeObserver = new ResizeObserver(place);
  const stop = () => {
    resizeObserver.disconnect();
    window.removeEventListener('load', place);
    userEvents.forEach((type) => window.removeEventListener(type, stop));
    history.scrollRestoration = 'auto';
  };

  place();
  resizeObserver.observe(document.body);
  window.addEventListener('load', place);
  userEvents.forEach((type) => window.addEventListener(type, stop, { passive: true }));
  setTimeout(stop, 4000);
};

const restoreLoadedPages = async () => {
  let state = null;
  try {
    state = JSON.parse(sessionStorage.getItem(LOAD_MORE_RESTORE_KEY));
  } catch (error) {}

  // Came back to the history entry we marked on the click. Safari can't be trusted for this: on the back button it
  // reports how the page was first opened ('navigate' on a first visit, 'reload' after a refresh).
  const cameBack = !!(history.state && history.state.loadMoreRestore);
  if (!state || !cameBack || state.url !== currentListUrl()) return;

  // We scroll ourselves; the browser can't reach the old position yet
  history.scrollRestoration = 'manual';

  const button = document.querySelector('.js-load-more');
  const startPage = currentPageNumber();
  const lastPage = Math.min(state.page, parseInt($('[data-total-pages]').val()) || startPage);

  if (button && lastPage > startPage) {
    button.setAttribute('disabled', '');
    button.classList.add('loading');

    try {
      for (let page = startPage + 1; page <= lastPage; page++) {
        await appendPage(page);
      }
    } catch (error) {
      history.scrollRestoration = 'auto';
      button.removeAttribute('disabled');
      button.classList.remove('loading');
      return;
    }

    $('[data-current-page]').val(lastPage);
    button.removeAttribute('disabled');
    button.classList.remove('loading');
    if (lastPage >= parseInt($('[data-total-pages]').val())) button.remove();
    colorSwatches();
  }

  keepItemInPlace(state);
};

restoreLoadedPages();

// Safari sometimes shows the page from its back/forward cache instead of reloading it, and then at the top.
// The items are still there, so only scroll back to the clicked one.
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;

  let state = null;
  try {
    state = JSON.parse(sessionStorage.getItem(LOAD_MORE_RESTORE_KEY));
  } catch (error) {}
  if (state && state.url === currentListUrl()) keepItemInPlace(state);
});
